import React, { useEffect, useState } from "react";
import { DEVICE_DETAILS } from "config";
import { useHistory } from "react-router-dom";
import { Autocomplete } from "@material-ui/lab";
import Header from "components/Header";
import TestEnvironment from "components/TestEnvironment";
import  TranslationProvider  from "providers/TranslationProvider";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { dateConfig } from "config";
import {
  Card,
  CardContent,
  Button,
  IconButton,
  CircularProgress,
  Container,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Radio,
  RadioGroup,
  Typography,
  TextField,
  Select,
  Checkbox,
  MenuItem,
  InputLabel,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import CancelIcon from "@material-ui/icons/Cancel";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { SENTINEL_COACH_FORM_SUCCESS } from "navigation/CONSTANTS";
import { saveSentinelCoachWVForm } from "../../services/wvForms";
import { SET_EMPTY } from "../../config";
import { uploadSentinelCoachFiles, getFileUrl } from "services";
import { set } from "date-fns";
import { updateLang } from "i18n";
import { getUserDetails } from "services";
import { isEmptyObject } from "utils";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { properCase } from "utils";
import { AccessTime as Watch, DateRange, Close } from "@material-ui/icons";
import moment from "moment";

const KEY = "SentinelCoachForm";
const DISABLE_OBJECT = {
  name: false,
  email: false,
  managerName: false,
  managerEmail: false,
  country: false,
};


const useStyles = makeStyles((theme) => ({
  header: {
    border: `1px solid #dadce0`,
    wordWrap: "break-word",
    pageBreakInside: "avoid",
    background: "#fff",
    borderRadius: 8,
    borderTopWidth: 10,
    borderTopColor: theme.palette.primary.main,
    marginTop: 10,
  },
  root: {
    minWidth: "80%",
  },
  form: {
    "&>*": {
      marginBottom: 16,
    },
  },
  textField: {
    minWidth: "50%",
  },
  textArea: {
    width: "100%",
  },
}));

//const { t, i18n } = useTranslation();

const errorMessageObject = {
  empId: SET_EMPTY,
  empName: SET_EMPTY,
  empManagerName: SET_EMPTY,
  empManagerEmail: SET_EMPTY,
  empCountry: SET_EMPTY,
  duration: SET_EMPTY,
  businessLine: SET_EMPTY,
  otherBusinessLine: SET_EMPTY,
  task: SET_EMPTY,
  otherTask: SET_EMPTY,
  //comments: SET_EMPTY,
};

const MAIL_FORMAT_RE = /^[A-Za-z0-9_.-]+\w*@ironmountain\.+(\w*\.?\w{2,7})+$/;

const SentinelCoachForm = () => {
  const history = useHistory();
  const theme = useTheme();
  const classes = useStyles();

  const [empId, setEmpId] = useState("");
  const [empManagerName,setEmpManagerName] = useState("");
  const [empManagerEmail,setEmpManagerEmail] = useState("");
  const [businessLine, setBusinessLine] = useState("");
  const [isOtherBusinessVisible, setOtherBusinessVisible] = useState(false);
  const [otherBusinessLine, setOtherBusinessLine] = useState("");
  const [empName, setEmpName] = useState("");
  const [maskedEmpName, setMaskedEmpName] = useState("");
  //const [empEmailVisible, setEmpEmailVisible] = useState(true);
  const [empCountry, setEmpCountry] = useState("");
  const [empDetailsDisabled, setEmpDetailsDisabled] = useState(DISABLE_OBJECT);
  const [empDuration, setEmpDuration] = useState("");
  const [empExists, setEmpExists] = useState(false);
  const [taskSelected, setTaskSelected] = useState([]);
  const [isOtherTaskVisible, setIsOtherTaskVisible] = useState(false);
  const [otherTask, setOtherTask] = useState("");
  const [comments, setComments] = useState("");
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [errorMessage, setErrorMessage] = useState(errorMessageObject);
  const [fetchedUser, setFetchedUser] = useState(false);
  const [isSubmitPressed, setIsSubmitPressed] = useState(false);
  const [taskOpen, setTaskOpen] = useState(false);
  const [businessOpen, setBusinessOpen] = useState(false);
  const [errorAlertDiag, setErrorAlertDiag] = useState(false);
  const [empisActive,setEmpisActive]= useState(true);
  const [selectedDate,setSelectedDate]= useState(new Date());
  const [selectDateErr, setSelectDateErr] = React.useState(false);
  //const [coachingDate, setcoachingDate] =  useState(new Date());
  const { t, i18n } = useTranslation();

  const businessLineOptions = [
  { id: "1", value: "Record Center", label: t("other.lblBusinessRecordCenter") },
  { id: "2", value: "Transportation", label: t("other.lblBusinessTransportation") },
  { id: "3", value: "Data Management", label: t("other.lblBusinessDataManagement") },
  { id: "4", value: "Digital Services (Imaging)", label: t("other.lblBusinessDigitalServices") },
  { id: "5", value: "Consumer Storage", label: t("other.lblBusinessConsumerStorage") },
  { id: "6", value: "Asset Lifecycle Management", label: t("other.lblBusinessAssetLifecycleManagement")},
  { id: "7", value: "Warehousing and Logistics",label: t("other.lblBusinessWarehousingAndLogistics")},
  { id: "8", value: "Shred Plant",label: t("other.lblBusinessShredPlant")},
  { id: "9", value: "Other", label: t("other.lblOther") },
];
  const durationOptions = [
    { id: "1", value: "0.25", label: "0.25" },
    { id: "2", value: "0.50", label: "0.50" },
    { id: "3", value: "0.75", label: "0.75" },
    { id: "4", value: "1", label: "1" },
    { id: "5", value: "1.25", label: "1.25" },
    { id: "6", value: "1.50", label: "1.50" },
    { id: "7", value: "1.75", label: "1.75" },
    { id: "8", value: "2", label: "2" },
    { id: "9", value: "2.25", label: "2.25" },
    { id: "10", value: "2.50", label: "2.50" },
    { id: "11", value: "2.75", label: "2.75" },
    { id: "12", value: "3", label: "3" },
    { id: "13", value: "3.25", label: "3.25" },
    { id: "14", value: "3.50", label: "3.50" },
    { id: "15", value: "3.75", label: "3.75" },
    { id: "16", value: "4", label: "4" },
    { id: "17", value: "4.25", label: "4.25" },
    { id: "18", value: "4.50", label: "4.50" },
    { id: "19", value: "4.75", label: "4.75" },
    { id: "20", value: "5", label: "5" },
    { id: "21", value: "5.25", label: "5.25" },
    { id: "22", value: "5.50", label: "5.50" },
    { id: "23", value: "5.75", label: "5.75" },
    { id: "24", value: "6", label: "6" },
    { id: "25", value: "6.25", label: "6.25" },
    { id: "26", value: "6.50", label: "6.50" },
    { id: "27", value: "6.75", label: "6.75" },
    { id: "28", value: "7", label: "7" },
    { id: "29", value: "7.25", label: "7.25" },
    { id: "30", value: "7.50", label: "7.50" },
    { id: "31", value: "7.75", label: "7.75" },
    { id: "32", value: "8", label: "8" },
    { id: "33", value: "8.25", label: "8.25" },
    { id: "34", value: "8.50", label: "8.50" },
    { id: "35", value: "8.75", label: "8.75" },
    { id: "36", value: "9", label: "9" },
    { id: "37", value: "9.25", label: "9.25" },
    { id: "38", value: "9.50", label: "9.50" },
    { id: "39", value: "9.75", label: "9.75" },
    { id: "40", value: "10", label: "10" },
    { id: "41", value: "10.25", label: "10.25" },
    { id: "42", value: "10.50", label: "10.50" },
    { id: "43", value: "10.75", label: "10.75" },
    { id: "44", value: "11", label: "11" },
    { id: "45", value: "11.25", label: "11.25" },
    { id: "46", value: "11.50", label: "11.50" },
    { id: "47", value: "11.75", label: "11.75" },
    { id: "48", value: "12", label: "12" }
   
 ];
  const taskOption = [
    { id: "1", value: "New Hire - Onboarding Activities (Workday)", label: t("other.lblTaskOnboardingActivities")  },
    { id: "2", value: "New Hire - Driver Qualification (DQ) Packet", label: t("other.lblTaskDriverQualification")  },
    { id: "3", value: "New Hire - Health and Safety (Safety 24/7, SMD etc.)", label: t("other.lblTaskNewHireHealthSafety") },
    { id: "4", value: "New Hire - Sentinel Learning Roadmap (Job Specific)", label: t("other.lblTaskNewHireSentinelLearningRoadmap") },
    { id: "5", value: "New Hire - IMLearning (Sentinel)", label: t("other.lblTaskNewHireIMLearning") },
    { id: "6", value: "Retrain - Job Specific (Operating Procedures, How To)", label: t("other.lblTaskRetrainJobSpecific")  },
    { id: "7", value: "Retrain - Health and Safety", label: t("other.lblTaskRetrainHealthSafety") },
    { id: "8", value: "Huddle - Job Specific (Operating Procedures, How To)", label: t("other.lblTaskHuddleJobSpecific") },
    { id: "9", value: "Huddle - Health and Safety", label: t("other.lblTaskHuddleHealthSafety") },
    { id: "10", value: "Powered Industrial Truck Certification", label: t("other.lblTaskPoweredIndustrialTruckCertification") },
    { id: "11", value: "Monthly Training Assignment", label:t("other.lblTaskMonthlyTrainingAssignment") },
    { id: "12", value: "Mentoring", label: t("other.lblTaskMentoring") },
    { id: "13", value: "Other", label: t("other.lblOther") },
  ];
  const getEmpDetails = async (empId) => {
    await getUserDetails(empId)
      .then((details) => {
        const empDetails = details.data();
        if (empDetails) {
          let firstName = empDetails.firstName;
          let lastName = empDetails.lastName;
          let managerLastName = empDetails?.managerLastName;
          let managerFirstName = empDetails?.managerFirstName;
          var regex =/\b(\w{1,3})(\w{2,}?)(\w?)\b/g;
          var regex1 =/\b(\w{1})(\w{2,}?)(\w?)\b/g;
          let maskedFirstName;
          let maskedSecondName;
          if(firstName) maskedFirstName= firstName.replace(
            regex,
            (_, first, middle, last) => `${first}${'*'.repeat(middle.length)}${'*'.repeat(last.length)}`
          );
          if(lastName) maskedSecondName = lastName.replace(
            regex1,
            (_, first, middle, last) => `${first}${'*'.repeat(middle.length)}${'*'.repeat(last.length)}`
          );
          setEmpName(`${firstName} ${lastName}`);
          setEmpManagerEmail(empDetails.managerEmail ? empDetails.managerEmail : SET_EMPTY);
          setEmpManagerName(`${managerFirstName} ${managerLastName}`)
          setMaskedEmpName(`${maskedFirstName} ${maskedSecondName}`)
         // setEmpEmail(empDetails.email ? empDetails.email : SET_EMPTY);
          //setEmpEmailVisible(empDetails.email ? false : true)
          setEmpExists(true);
          setEmpCountry(empDetails.country ? empDetails.country : SET_EMPTY);
          const disableObject = {
            name: `${empDetails.firstName} ${empDetails.lastName}`
              ? true
              : false,
            empManagerEmail: empDetails.managerEmail ? true : false,
            empManagerName: `${managerFirstName} ${managerLastName}` ? true : false,
           country: empDetails.country ? true : false,
          };
          console.log("disableObject",disableObject);
          if(empDetails.isActiveWorker===true){
            setEmpisActive(true)
          }
          else{
            setEmpisActive(false)
            setEmpName(SET_EMPTY);
            setMaskedEmpName(SET_EMPTY)
            setEmpCountry(SET_EMPTY);
            setEmpDetailsDisabled(DISABLE_OBJECT);
            setEmpManagerEmail(SET_EMPTY);
            setEmpManagerName(SET_EMPTY);
          }
           
            
          if (isSubmitPressed) {
            const errObject = {
              empName: disableObject.name ? "" : t("other.lblRequired"),
              empManagerName: disableObject.empManagerName ? "" : t("other.lblRequired"),
              empManagerEmail: disableObject.empManagerEmail
                ? ""
                : t("other.lblRequired"),
              empCountry: disableObject.country ? "" : t("other.lblRequired"),
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));
          }
          setEmpDetailsDisabled(disableObject);
          
        } else {
          setEmpName(SET_EMPTY);
          //setEmpEmail(SET_EMPTY);
          //setEmpEmailVisible(true);
          setMaskedEmpName(SET_EMPTY)
          setEmpCountry(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
          setEmpExists(false);
          setEmpManagerEmail(SET_EMPTY);
          setEmpManagerName(SET_EMPTY);
        }
      })
      .catch((error) => {
        setEmpName(SET_EMPTY);
        setMaskedEmpName(SET_EMPTY)
        //setEmpEmail(SET_EMPTY);
        //setEmpEmailVisible(true);
        setEmpCountry(SET_EMPTY);
        setEmpDetailsDisabled(DISABLE_OBJECT);
        setEmpExists(false);
        setEmpManagerEmail(SET_EMPTY);
        setEmpManagerName(SET_EMPTY);
        console.log("Error in get Employee Details" + error);
      });
    setFetchedUser(true);
  };

  const handleEmpIdChange = async (event) => {
    const value = event.target.value;
    if (value.length < 8) {
      const lastCharacter = value.charAt(value.length - 1);
      const isNumber = !isNaN(lastCharacter - parseFloat(lastCharacter));
      if (isNumber || isEmptyObject(value)) {
        handleOnBlur(event);
        if (value.length > 5) {
            await getEmpDetails(value);
            setEmpId(value);
        } else {
          setEmpId(value);
          setEmpName(SET_EMPTY);
          setMaskedEmpName(SET_EMPTY)
          setEmpManagerEmail(SET_EMPTY);
          setEmpManagerName(SET_EMPTY);
          setEmpCountry(SET_EMPTY);
          setEmpDetailsDisabled(DISABLE_OBJECT);
          setEmpExists(false);
          
          if (isSubmitPressed) {
            const errObject = {
              empName: "",
              empManagerName: "",
              empManagerEmail: "",
              empCountry: "",
            };
            setErrorMessage((oldState) => ({
              ...oldState,
              ...errObject,
            }));
          }
        }
      }
    }
  };
  const coachingDateChange = (date) => {
    if (!moment(date).isValid() ) {
    
      setSelectDateErr(true);
    } else {
      setSelectedDate(date);
      //handleOnBlur(event);
      setSelectDateErr(false);
    }
  };
  // const handleBusinessLineChange = (event, value) => {
  //   if (value) {
  //     const isOther = value.filter((cat) => cat.value === "Other");
  //     //const isOther = event.target.value === "Other"
  //     if (isOther) {
  //       setOtherBusinessVisible(true);
  //     } else {
  //       setOtherBusinessVisible(false);
  //       setOtherBusinessLine(SET_EMPTY);
  //     }
  //     handleOnBlurBusiness(value);
  //     setBusinessLine(value);
  //   }
  // };
  const handleBusinessLineChange = (event) => {
    
    const value = event.target.value;
    //alert(value)
    if (value === 'Other') {
            setOtherBusinessVisible(true);
          } else {
            setOtherBusinessVisible(false);
            setOtherBusinessLine(SET_EMPTY);
          }

   // handleOnBlurBusiness(event);
    handleOnBlur(event);
    setBusinessLine(value);
  };
  const handleOtherBusinessChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setOtherBusinessLine(value);
  };

  const handleTaskChange = (event, value) => {
    //const unique = [...new Set(value.map(item => item))];
    const taskArray = [...new Map(value.map(item =>
      [item['id'], item])).values()];
    console.log("arrayUniqueByKey",taskArray);
    const isOther = taskArray.some((cat) => cat.value === "Other");
    if (isOther) {
      setIsOtherTaskVisible(true);
    } else {
      setIsOtherTaskVisible(false);
      setOtherTask(SET_EMPTY);
    }
    handleOnBlurTask(taskArray);
    setTaskSelected(taskArray);
    
  };
 
  const handleOtherTaskChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setOtherTask(value);
  };

  const handleCommentsChange = (event) => {
    const value = event.target.value;
    //handleOnBlur(event);
    setComments(value);
  };

  const handleNameChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpName(value);
  };
 
  const handleCountryChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpCountry(value);
  };

  const handleDurationChange = (event) => {
    const value = event.target.value;
    handleOnBlur(event);
    setEmpDuration(value);
  };


  const handleProcessingOpen = () => {
    setProcessing(true);
  };

  const handleProcessingClose = () => {
    setProcessing(false);
  };

  const validateEmail = (email) => {
    if (MAIL_FORMAT_RE.test(email)) {
      if (email.length - "@ironmountain".length !== -1) {
    
        //VALID
        return true;
      }
    }
  };

  const handleOnBlur = (event) => {
    const target = event.target;
    if (target.id) {
      if (
        !target.value ||
        target.value === null ||
        target.value.trim() === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: t("other.lblRequired"),
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.id]: SET_EMPTY,
        }));
      }
    } else if (target.name) {
      if (
        target.value === undefined ||
        target.value === null ||
        target.value === SET_EMPTY
      ) {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: t("other.lblRequired"),
        }));
      } else {
        setErrorMessage((oldState) => ({
          ...oldState,
          [target.name]: SET_EMPTY,
        }));
      }
    }
  };

 
  const handleOnBlurTask = (value) => {
    if (isEmptyObject(value)) {
      setErrorMessage((oldState) => ({
        ...oldState,
        task: t("other.lblRequired"),
      }));
    } else {
      setErrorMessage((oldState) => ({
        ...oldState,
        task: SET_EMPTY,
      }));
    }
  };

  const handleOnBlurBusiness = (value) => {
    if (isEmptyObject(value)) {
      setErrorMessage((oldState) => ({
        ...oldState,
        businessLine: t("other.lblRequired"),
      }));
    } else {
      setErrorMessage((oldState) => ({
        ...oldState,
        businessLine: SET_EMPTY,
      }));
    }
  };

  const checkErrors = () => {
    const errorMessages = {
      empId: SET_EMPTY,
      empName: SET_EMPTY,
      empManagerName: SET_EMPTY,
      empManagerEmail: SET_EMPTY,
      empCountry: SET_EMPTY,
      duration: SET_EMPTY,
      businessLine: SET_EMPTY,
      otherBusinessLine: SET_EMPTY,
      task: SET_EMPTY,
      otherTask: SET_EMPTY, 
     // comments: SET_EMPTY,
    };
    const REQUIRED = t("other.lblRequired");

    if (empId.trim() === SET_EMPTY) {
      errorMessages.empId = REQUIRED;
    } else if (empId.trim().length < 6) {
      errorMessages.empId = t("other.lblMinimumSixDigitsRequired");
    } else {
      errorMessages.empId = SET_EMPTY;
    }

    if (empName.trim() === SET_EMPTY) {
      errorMessages.empName = REQUIRED;
    } else {
      errorMessages.empName = SET_EMPTY;
    }

    
    if (empManagerName.trim() === SET_EMPTY) {
      errorMessages.empManagerName = REQUIRED;
    } else {
      errorMessages.empManagerName = SET_EMPTY;
    }

    if (empManagerEmail.trim() === SET_EMPTY) {
      errorMessages.empManagerEmail = REQUIRED;
    } else if (!validateEmail(empManagerEmail.trim())) {
      errorMessages.empManagerEmail = "Enter Iron Mountain ID";
    } else {
      errorMessages.empManagerEmail = SET_EMPTY;
    }
    

    if (empCountry.trim() === SET_EMPTY) {
      errorMessages.empCountry = REQUIRED;
    } else {
      errorMessages.empCountry = SET_EMPTY;
    }

    if (empDuration.trim() === SET_EMPTY) {
      errorMessages.duration = REQUIRED;
    } else {
      errorMessages.duration = SET_EMPTY;
    }

    

    if (businessLine === SET_EMPTY) {
      errorMessages.businessLine = REQUIRED;
    } else {
      errorMessages.businessLine = SET_EMPTY;
    }

    if (isOtherBusinessVisible && otherBusinessLine.trim() === SET_EMPTY) {
      errorMessages.otherBusinessLine = REQUIRED;
    } else {
      errorMessages.otherBusinessLine = SET_EMPTY;
    }

    if (isEmptyObject(taskSelected)) {
      errorMessages.task = REQUIRED;
    } else {
      errorMessages.task = SET_EMPTY;
    }

    if (isOtherTaskVisible && otherTask.trim() === SET_EMPTY) {
      errorMessages.otherTask = REQUIRED;
    } else {
      errorMessages.otherTask = SET_EMPTY;
    }
     setErrorMessage(errorMessages);
  };



  const onClear = () => {
    setIsSubmitPressed(false);
    setEmpId(SET_EMPTY);
    setEmpName(SET_EMPTY);
    setMaskedEmpName(SET_EMPTY);
    //setEmpEmail(SET_EMPTY);
    //setEmpEmailVisible(true);
    setEmpCountry(SET_EMPTY);
    setEmpDuration(SET_EMPTY);
    setBusinessLine([]);
    setOtherBusinessVisible(false);
    setOtherBusinessLine(SET_EMPTY);
    setTaskSelected([]);
    setIsOtherTaskVisible(false);
    setOtherTask(SET_EMPTY);
    setComments(SET_EMPTY);
    setEmpDetailsDisabled(DISABLE_OBJECT);
    setSelectedDate(new Date());

    // setFileList([]);
    setErrorMessage(errorMessageObject);
    setEmpManagerEmail(SET_EMPTY);
    setEmpManagerName(SET_EMPTY);
  };

  const onSubmit = async () => {
    checkErrors();
    setIsSubmitPressed(true);
    if (!isSubmitDisabled) {
      let taskToUpload = taskSelected.map((cat) => cat.value);
      let businessLineToUpload = businessLine.trim();

      if (isOtherTaskVisible) {
        taskToUpload.push(otherTask.trim());
        taskToUpload = taskToUpload.filter(
          (cat) => cat !== "Other"
        );
      }

      if (isOtherBusinessVisible) {
        businessLineToUpload= otherBusinessLine.trim();
      }

      let form = {
        key: KEY,
        empId: empId.trim(),
        empName: empName.trim(),
        empManagerName: empManagerName.trim(),
        empManagerEmail: empManagerEmail.trim(),
        duration: empDuration.trim(),
        location: empCountry.trim(),
        businessLine: businessLineToUpload,
        task: taskToUpload,
        comments: comments.trim(),
        coachingDate : moment(selectedDate).format(dateConfig.format9),
        deviceType: DEVICE_DETAILS.deviceType,
      };
      handleProcessingOpen();
      try {
        // let filePathArray = await uploadSentinelCoachFiles(fileList, empId);
        // console.log("File paths for the uploaded files are  ", filePathArray);
        // let urlArray = await getFileUrl(filePathArray);
        // console.log("File urls for the uploaded files are ", urlArray);
        // form.filePaths = urlArray;
        let sentinelCoachFormID = await saveSentinelCoachWVForm(form);
        console.log(`
        sentinelCoach-form
        sentinelCoachFormID is ${sentinelCoachFormID}
      `);
        handleProcessingClose();
        history.push(SENTINEL_COACH_FORM_SUCCESS);
      } catch (error) {
        console.log(`
        sentinelCoachSurvey-form 
      error is ${error}
     `);
    }
    } else {
      setErrorAlertDiag(true);
    }
  };
  const {version}=useSelector((state)=>state.translation.i18n)
  if (version && version>1) {
    updateLang();
  }
  useEffect(() => {
    const header = document.querySelector("#header-bar");
    const testEnv = document.querySelector(".imtime-testEnvironment");
    if (header) header.style.display = "none";
    if (testEnv) testEnv.style.display = "none";
  }, []);

  useEffect(() => {
    if (
      empId.trim().length < 6 ||
      empName.trim() === SET_EMPTY ||
      !validateEmail(empManagerEmail.trim()) ||
      empManagerName.trim() === SET_EMPTY ||
      empManagerEmail.trim() === SET_EMPTY ||
      empCountry.trim() === SET_EMPTY ||
      empDuration.trim() === SET_EMPTY ||
      businessLine.trim() === SET_EMPTY ||
      (isOtherBusinessVisible && otherBusinessLine.trim() === SET_EMPTY) ||
      isEmptyObject(taskSelected) ||
      (isOtherTaskVisible && otherTask.trim() === SET_EMPTY) 
      // fileList.length === 0
    ) {
      setIsSubmitDisabled(true);
    } else {
      setIsSubmitDisabled(false);
    }
  }, [
    empId,
    empName,
    empManagerEmail,
    empManagerName,
    empCountry,
    empDuration,
    businessLine,
    isOtherBusinessVisible,
    otherBusinessLine,
    taskSelected,
    isOtherTaskVisible,
    otherTask,
    comments,
    // isSubmitPressed,
  ]);
useEffect(() => {
    document.title = 'Sentinel Coach | Activity Log';
  });
  return (
    <>
      <Container maxWidth="sm">
        <form className={classes.form} noValidate autoComplete="off">
        {/* <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>  
            </Grid>
         </Grid>    */}
          <Grid container direction="column" alignItems="stretch" spacing={2}>
            <Grid item>
            <TranslationProvider />                         
                <Header  isLogoLinkDisabled={DEVICE_DETAILS.deviceType === "mobile" ? true : false}/>
              <Card className={classes.header}>
                <CardContent>
                  <Typography variant="h6" gutterBottom color="textPrimary">                    
                    {t("other.lblSentinelCoach")}
                  </Typography>
                  <Typography variant="body2" gutterBottom>
                  {t("other.lblSentinelCoachHeading")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourWorkerId")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <TextField
                    value={empId}
                    onChange={handleEmpIdChange}
                    id="empId"
                    label={t("other.lblEnterYourWorkerId")}
                    className={classes.textField}
                    style={{width: 250}}
                    // onBlur={handleOnBlur}
                    error={!!errorMessage.empId}
                    helperText={
                      !!errorMessage.empId
                        ? errorMessage.empId
                        : empId.trim().length < 6
                        ? t("other.lblMinimumSixDigitsRequired")
                        : ""
                    }
                  />
                  {!empExists && empId.length > 5 ?(
                    <Typography
                      variant="subtitle2"
                      gutterBottom
                      color="textPrimary"
                      style={{color:"red"}}
                    >
                      {t("pgHome.errNotFoundWorker")}                   
                    </Typography>
                  ): !empisActive  && empId.length > 5 &&
                  (
                    <Typography
                    variant="subtitle2"
                    gutterBottom
                    color="textPrimary"
                    style={{color:"red"}}
                  >
                    {t("pgHome.errInactiveWorker")}
                  </Typography>	
                  )}
                </CardContent>
              </Card>
            </Grid>

            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblYourDetails")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  
                  {/*  */}
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <TextField
                        value={maskedEmpName?maskedEmpName:empName}
                        onChange={handleNameChange}
                        disabled={empDetailsDisabled.name}
                        id="empName"
                        label={t("pgHome.lblName")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empName}
                        helperText={errorMessage.empName}
                      />
                    </Grid>
                    
                    <Grid item>
                      <TextField
                        value={empCountry}
                        onChange={handleCountryChange}
                        disabled={empDetailsDisabled.country}
                        id="empCountry"
                        label={t("other.tlCountry")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empCountry}
                        helperText={errorMessage.empCountry}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        value={empManagerName?empManagerName:empManagerName}
                       // onChange={handleChange}
                        disabled={empDetailsDisabled.empManagerName}
                        id="empManagerName"
                        label={t("other.lblManager")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empManagerName}
                        helperText={errorMessage.empManagerName}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        value={empManagerEmail?empManagerEmail:empManagerEmail}
                       // onChange={handleChange}
                        disabled={empDetailsDisabled.empManagerEmail}
                        id="empManagerEmail"
                        label={t("other.tableManagerEmail")}
                        className={classes.textField}
                        // onBlur={handleOnBlur}
                        error={!!errorMessage.empManagerEmail}
                        helperText={errorMessage.empManagerEmail}
                      />
                    </Grid>
                  </Grid>
                  {/*  */}
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblTask")}                    
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Grid
                    container
                    direction="column"
                    alignItems="stretch"
                    spacing={1}
                  >
                    <Grid item>
                      <Autocomplete
                        multiple
                        id="task"
                        type="dropdown"
                        open={taskOpen}
                        onOpen={() => setTaskOpen(true)}
                        onClose={() => {}}
                        style={{ width: 270,
                        zIndex: 9999,
                        bottom: 0,
                        scroll:true,
                       // height:20,
                      //  overflowX: 'auto',
                       }}
                       className={classes.textField}
                        options={taskOption}
                        getOptionLabel={(option) => option.label}
                        value={taskSelected}
                        onChange={handleTaskChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            error={
                              !!errorMessage.task &&
                              isEmptyObject(taskSelected)
                            }
                            helperText={
                              !!errorMessage.task &&
                              isEmptyObject(taskSelected)
                                ? t("other.lblRequired")
                                : ""
                            }
                            label={t("other.lblSelectAllThatApply")}
                          />
                        )}
                        onBlur={() => setTaskOpen(false)}
                      />
                    </Grid>
                    <Grid item>
                      {isOtherTaskVisible && (
                        <TextField
                          id="otherTask"
                          label={t("other.lblOther")}
                          className={classes.textField}
                          value={otherTask}
                          onChange={handleOtherTaskChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.otherTask}
                          helperText={errorMessage.otherTask}
                        />
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblSentinelBusinessLine")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <Grid
                  //   container
                  //   direction="column"
                  //  // alignItems="stretch"
                  //   //spacing={1}
                  >
                  <Grid item>
                       <FormControl variant="outlined">
                        <InputLabel id="businessLine-label">{t("other.lblChoose")}</InputLabel>
                        <Select
                          labelId="businessLine-label"
                          id="businessLine"
                          name="businessLine"
                          style={{ width: 260 }}
                          className={classes.textField}
                          label={t("other.lblChoose")}
                          value={businessLine}
                          onChange={handleBusinessLineChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.businessLine}
                          helperText={errorMessage.businessLine}
                        >
                          {businessLineOptions.map((businessLine) => (
                            <MenuItem value={businessLine.value}>{businessLine.label}</MenuItem>
                          ))}
                        </Select>
                       </FormControl>
                     </Grid>
                    <Grid item>
                      {isOtherBusinessVisible && (
                        <TextField
                          id="otherBusinessLine"
                          label={t("other.lblOther")}
                          className={classes.textField}
                          value={otherBusinessLine}
                          onChange={handleOtherBusinessChange}
                          // onBlur={handleOnBlur}
                          error={!!errorMessage.otherBusinessLine}
                          helperText={errorMessage.otherBusinessLine}
                        />
                      )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card className={classes.root}>
                  <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblCoachingDate")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                      <Grid
                        container
                        direction="column"
                        alignItems="stretch"
                        spacing={1}
                      >
                        <Grid item>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                              // disableBackdropClick
                              ampm={false}
                              placeholder="MM/dd/yyyy"
                              margin="none"
                              id="date-picker-dialog"
                              format="MM/dd/yyyy"
                              value={selectedDate}
                              onChange={coachingDateChange}
                              onInputChange={coachingDateChange}
                              //minDate={moment(new Date()).startOf("week")}
                              maxDate={moment(new Date())}
                              inputVariant="outlined"
                              size="small"
                              style={{ width: 260 }}
                              label={properCase(t("other.lblDate"))}
                              keyboardIcon={<DateRange fontSize="inherit" />}
                              helperText={
                                selectDateErr && t("pgAddEditPunchSupervisor.lblInvalidDate")
                              }
                              invalidDateMessage={t("pgAddEditPunchSupervisor.lblInvalidDate")}
                              error={selectDateErr}
                            />
                            </MuiPickersUtilsProvider>
                        </Grid> 
                        </Grid>   
                  </CardContent>
                </Card>
            </Grid>
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblDuration")}
                    <span style={{ color: "red" }}>*</span>
                  </Typography>
                  <FormControl variant="outlined">
                    <InputLabel id="duration-label">{t("other.lblChoose")}</InputLabel>
                    <Select
                      labelId="duration-label"
                      id="duration"
                      name="duration"
                      style={{ width: 260 }}
                      label={t("other.lblChoose")}
                      className={classes.textField}
                      value={empDuration}
                      onChange={handleDurationChange}
                      // onBlur={handleOnBlur}
                      error={!!errorMessage.duration}
                      helperText={errorMessage.duration}
                    >
                      {durationOptions.map((duration) => (
                        <MenuItem value={duration.value}>{duration.label}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </CardContent>
              </Card>
            </Grid>
            <Grid item>
              <Card className={classes.root}>
                <CardContent>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    color="textPrimary"
                  >
                    {t("other.lblComments")}  </Typography>
                  <TextField
                    value={comments}
                    onChange={handleCommentsChange}
                    id="comments"
                    label={t("other.lblComments")} 
                    className={classes.textArea}
                    multiline
                    // onBlur={handleOnBlur}
                   // error={!!errorMessage.comments}
                   // helperText={errorMessage.comments}
                  />
                </CardContent>
              </Card>
            </Grid>
            
            <Grid item>
              <Grid
                container
                direction="row"
                justify="space-between"
                spacing={2}
              >
                <Grid item>
                  <Button
                    type="Button"
                    variant="text"
                    color="secondary"
                    onClick={onClear}
                  >
                    {t("other.lblClearForm")}                    
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={onSubmit}
                    disabled={ !empExists && empId.length > 5 || !empisActive }
                  >
                    {t("pgHome.btEmpId")}                    
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Container>
      <Dialog
        open={processing}
        onClose={handleProcessingClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="alert-dialog-title">{t("other.lblSubmitting")} </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
          {t("other.lblPleaseWaitToSubmt")}   <br /> <br />
            <Grid container justify="center">
              <Grid item>
                <CircularProgress />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
      <Dialog
        open={errorAlertDiag}
        onClose={() => {
          setErrorAlertDiag(false);
        }}
        aria-labelledby="error-dialog-title"
        aria-describedby="error-dialog-description"
        disableBackdropClick={true}
      >
        <DialogTitle id="error-dialog-title"> {t("other.tlError")}</DialogTitle>
        <DialogContent>
          <DialogContentText id="error-dialog-description">
          {t("other.lblPleaseFillAllFields")}  <br /> <br />
             <Grid container justify="flex-end">
              <Grid item>
                <Button
                  variant="contained"
                  color="primary"
                  style={{ width: 90 }}
                  onClick={() => {
                    setErrorAlertDiag(false);
                  }}
                >
                 {t("pgPunch.btnOK")} 
                </Button>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default SentinelCoachForm;
